import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-campo-dinheiro',
  templateUrl: './campo-dinheiro.component.html',
  styleUrls: ['./campo-dinheiro.component.css']
})
export class CampoDinheiroComponent implements OnInit {

  @Input() formulario: UntypedFormGroup;
  @Input() descricao: string = '';
  @Input() tipo: string = 'text';
  @Input() modoInsercao: string = 'text';
  @Input() nomeControle: string;
  @Input() autoPreenchimento: string;
  @Input() identificacao: string;
  @Input() textoAjuda: string;
  @Input() mascara: string = null;
  @Input() classe: string;
  @Input() botaoAcao: boolean = false;
  @Input() disabled: boolean = false;

  @Output() alteracao = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  change() {
    this.alteracao.emit();
  }

}
